import React, { Suspense } from 'react';
import { ControlWrapper } from './control.styles';
import { commonDateFieldValidation, commonDateValidations } from '../../AlmeUtilities/dateutils';
import { LazyDatepickerControl } from '../../Custom/Datepicker/LazyDatepickerControl';
import AlmeLoader from '../../AlmeLoader/AlmeLoader';
const DatePickerControl = (props) => {
    const isrequired = props.inputMetadata.required === 'true';
    const optionalText = isrequired ? "" : " (optional)";
    const onChange = (date) => {
        const error = commonDateValidations(date, isrequired, props.startDate, props.endDate);
        props.onChange({
            id: props.inputMetadata.id,
            isvalid: !error,
            value: date,
            error,
        });
    };
    const onInputBlur = (dateString) => {
        const error = commonDateFieldValidation(dateString, isrequired);
        if (error) {
            props.onChange({
                id: props.inputMetadata.id,
                isvalid: false,
                value: null,
                error,
            });
        }
    };
    const calendarProps = {
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select",
        shouldCloseOnSelect: false,
        adjustDateOnChange: true,
    };
    return (React.createElement(Suspense, { fallback: React.createElement(AlmeLoader, { loaded: false }) },
        React.createElement(ControlWrapper, { hasError: !!props.error },
            React.createElement(LazyDatepickerControl, Object.assign({ id: `Alme-Overlay-Form-${props.inputMetadata.id}`, value: props.value, minDate: props.startDate, maxDate: props.endDate, onChange: onChange, onBlur: onInputBlur, placeholder: props.inputMetadata.labeltext + `${optionalText}`, required: isrequired, error: props.error, overlay: false, isFirstOverlay: props.isFirstOverlay, showCalendar: props.showCalendar, shouldFocus: props.shouldFocus }, calendarProps)))));
};
export default DatePickerControl;
